import styled from 'styled-components';
import ComapnySvg from '../../assets/settings/company.svg';

const ComapnyIcon = styled(ComapnySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.8rem'};
height: ${props => props.height || '2rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default ComapnyIcon;
